module.exports = __webpack_public_path__ + "img/carshina22_19.f1c71f46.jpg";